export default "__VITE_ASSET__mHj7OnLJ__"